import { JobDatePostedValue } from "@/__generated__/graphql";
var datePostedValues = new Set(Object.values(JobDatePostedValue));
export function isJobDatePostedValue(value) {
    return datePostedValues.has(value);
}
